import React, {Component} from 'react';
import AppLink from "../AppLink";

class SubMenu extends Component {
  render() {
    const { item } = this.props;

    let cols = Math.ceil(item.children.length / 6);

    let children = [];
    for (let i = 0; i < cols; i++) {
      children[i] = [];
    }

    for (let j = 0; j < item.children.length; j++) {
      let child = item.children[j];
      children[j % cols].push(<AppLink key={child.url} to={child.url} type={'nav'}>{child.name || child.title}</AppLink>);
    }

    return (
      <div className={'sub-menu columns-' + cols}>
        <div className={'row'}>
          {children.map((childs, i) => {
            return (
              <div key={item.url + i} className={'col-' + (12 / cols)}>
                {childs.map(child => {
                  return child
                })}
              </div>
            )
          })}
        </div>
      </div>
    )
  }
}

export default SubMenu;